import StyleBase from '../../../base/Style.base';
import type { Style } from '../../../schema';
import type { IMergerClass } from '../../componentManifestResolver.types';
import type { StyleMergerConstructor } from './types';

class StyleMerger implements IMergerClass<Style> {
  private mainStyle: StyleBase;
  private referredStyle: Style = {};
  constructor({ mainStyle, referredStyle }: StyleMergerConstructor) {
    this.mainStyle = new StyleBase(mainStyle);
    if (referredStyle) {
      this.referredStyle = referredStyle;
    }
  }

  public merge() {
    const mergedStyle = {
      ...this.referredStyle,
      ...this.mainStyle.getStyle()
    };

    const { errors, valid } = StyleBase.validate(mergedStyle);

    if (!valid) {
      throw new Error(`Failed merging styles: 
         ${JSON.stringify(errors)}`);
    }

    return mergedStyle;
  }
}

export default StyleMerger;
